import { render } from "./SocialMediaItem.vue?vue&type=template&id=9562bb60&scoped=true"
import script from "./SocialMediaItem.vue?vue&type=script&lang=js"
export * from "./SocialMediaItem.vue?vue&type=script&lang=js"

import "./SocialMediaItem.vue?vue&type=style&index=0&id=9562bb60&scoped=true&lang=css"

import exportComponent from "/home/runner/work/joshpotterton.com/joshpotterton.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9562bb60"]])

export default __exports__